const $ = require('jquery');
import run from '../../utilities/run';
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import {isPresent} from "../../utilities/general";
import {setOptionsForSelect} from "../../utilities/selectorHelpers";
import typeAheadSource from "../../utilities/typeAheadSource";
import _ from "underscore";
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

// Live form from jsp
run("#collateral-rule-form", ()=>{
  const el = $("#collateral-rule-form");
  attachWizard(el);
  setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#collateral-rule-form");
  EditChecker.bindCancelButton(".collateral-rule-cancel-btn");
}

function attachWizard(el) {
  const productSkus = el.data("rule-product-skus");
  const channels = el.data("rule-channels");
  const submitRuleURL = el.data("submit-collateral-rule");
  const collateralSkus = el.data("rule-collateral-skus");
  const submitModalTitleTxt = el.data("submit-modal-title-txt");
  const submitModalBodyTxt = el.data("submit-modal-body-txt");
  const submitModalBtnTxt = el.data("submit-modal-btn-txt");
  const date = new Date();
  const doc = $(document);

  const defaultInclusionFrequency = el.data("collateral-inclusion-frequency-defaults");
  const inclusionFrequencySelect = el.find("#inclusion-frequency");

  const defaultOutOfStockHandling = el.data("collateral-out-of-stock-handling");
  const outOfStockHandlingSelect = el.find("#out-of-stock-handling");

  const defaultInclusionCondition = el.data("collateral-inclusion-condition");
  const inclusionConditionSelect = el.find("#inclusion-condition");

  const ruleSummarySection = el.find(".rule-summary-section");
  const orderValueInSummary= el.find(".order-value");

  const summaryEffectiveEndDate = el.find(".summaryEffectiveEndDate");
  const summaryEffectiveStartDate = el.find(".summaryEffectiveStartDate");

  const dateRangeInputs = el.find(".func-date-range-input");
  const existingRule = el.data("collateral-existing-rule");

  const typeAheadItems = el.data("rule-collateral-typeahead-skus");
  const existingCollateralSkus = el.data("existing-collateral-skus");

  const ruleSummaryInclusionCondition = el.find(".rule-summary-inclusion-condition");
  const ruleSummaryInclusionFrequency = el.find(".rule-summary-inclusion-frequency");
  const ruleSummaryOrderConditions = el.find('.order-conditions');
  const ruleSummaryOrderQuantity = el.find('.order-quantity');
  const ruleSummaryOrderQuantityValue = el.find('.order-quantity-value');
  const ruleSummaryOrderType = el.find('.order-type');
  const ruleSummaryOrderTypeValue = el.find('.order-type-value');
  const ruleSummaryOrderChannel = el.find('.order-channel');
  const ruleSummaryOrderChannelValue = el.find('.order-channel-value');
  const ruleSummaryConjunction = el.find('.order-conditions-conjunction');
  const ruleSummaryOrderSkuValue = el.find('.order-sku-value');

  const productsInOrderSelect2 = el.find("#productsInOrder");

  const collateralRuleConditionsDiv = el.find(".collateral-rule-conditions");

  const byValOfOrderToggler = el.find('#byValOfOrder');
  const byQuantityOfOrder=el.find('#byQuantityOfOrder');
  const byTypeOfOrder = el.find('#byTypeOfOrder');
  const byChannel = el.find('#byChannel');
  const productLookUpURL = el.data('product-lookup-url');

  let listBuild="";

  dateRangeInputs.datepicker({
    startDate: date,
    todayBtn: "linked",
    keyboardNavigation: false,
    autoclose: true
  });
  dateRangeInputs.datepicker().on("changeDate", function(){
    // THIS IS IMPORTANT, YOU MUST VALIDATE
    const dateInput = $(this);
    const otherDateInput = dateRangeInputs.not(dateInput);
    dateInput.valid();

    if(isPresent(validator.invalid[otherDateInput.attr("id")])){
      // always attempt to validate the opposite of the range if
      // other field has already been invalidated,
      // because jquery validation forces us to check
      // due to the fact that all validations
      // don't fire on change of one, so make sure
      // the range validation runs on change of either
      dateRangeInputs.not(dateInput).valid();
    }
  });

  $(".select2-select").on("change", function(){
    $(this).valid();
  });


  const select2AjaxDefaults = {
    dataType: 'json',
    delay: 250,
    processResults: function (data, params) {
      params.page = params.page || 1;
      return {
        results: data,
        pagination: {
        more: (params.page * 20) < data.total_count
        }
      };
    },
    cache: true
  }; 



  function configureDataCallback({paramKey}){
    return function(params){
      return {
        [paramKey] : params.term
      };
    };
  }


  setOptionsForSelect({
    selectElement: inclusionFrequencySelect,
    list: defaultInclusionFrequency,
    valueDataKey: "cdmValue",
    textDataKey: "cdmDescription",
    initialSelectValue: ()=>{
      return  existingRule.cbrInclusionFrequency || /per-order/i;
    }
  });

 if(existingRule.cbrInclusionFrequency !=null){
    inclusionFrequencySetup(inclusionFrequencySelect, existingRule.cbrInclusionFrequency);
  }else{
    inclusionFrequencySetup(inclusionFrequencySelect, "per-order");
  }

  inclusionFrequencySelect.on("change", function() {
    inclusionFrequencySetup(this.id, this.value);
  });

  setOptionsForSelect({
    selectElement: outOfStockHandlingSelect,
    list: defaultOutOfStockHandling,
    valueDataKey: "cdmValue",
    textDataKey: "cdmDescription",
    initialSelectValue: ()=>{
      return existingRule.cbrOutOfStockHandling || /release/i;
    }
  });

  setOptionsForSelect({
    selectElement: inclusionConditionSelect,
    list: defaultInclusionCondition,
    valueDataKey: "cdmValue",
    textDataKey: "cdmDescription",
    initialSelectValue: ()=>{
      return  existingRule.cbrInclusionCondition || /all-orders/i;
    }
  });

  if(existingRule.cbrInclusionCondition !=null){
    inclusionConditionSetup(inclusionConditionSelect, existingRule.cbrInclusionCondition);
  }else{
    inclusionConditionSetup(inclusionConditionSelect, "all-orders");
  }

   inclusionConditionSelect.on("change", function() {
    clearSummarySections();
    inclusionConditionSetup(this.id, this.value);
  });

  if(existingRule.cbrEffectiveStartDate!=null){
    summaryEffectiveStartDate.text("from "+ existingRule.cbrEffectiveStartDate);
  }else{
    summaryEffectiveStartDate.text("from " + $("#effectiveStartDate").val());
  }

  if(existingRule.cbrEffectiveEndDate!=null){
    summaryEffectiveEndDate.text("- "+ existingRule.cbrEffectiveEndDate);
  }else{
     summaryEffectiveEndDate.text("- "+ $("#effectiveEndDate").val());
  }

  $("#effectiveEndDate").on("change", function(){
    summaryEffectiveEndDate.text("- "+ $("#effectiveEndDate").val());
  });

  $("#effectiveStartDate").on("change", function(){
    summaryEffectiveStartDate.text("from " + $("#effectiveStartDate").val());
  });


  const dateRangeValidationObject = {
    dateRange: [
      {
        dateStart: ()=>{
          return $("#effectiveStartDate");
        },
        dateEnd: ()=>{
          return $("#effectiveEndDate");
        }
      }
    ]
  };

  const validator = $("#collateral-rule-form").validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },
    rules: {
      effectiveEndDate: dateRangeValidationObject,
      valOfOrder: {
        currencyDollarsCents: true
      },
      quantityOfOrderVal: {
        min: 1,
        wholeNumber: true
      }
    }
  });



  validator.settings.ignore = ":disabled,:hidden";

  const costRetailBtnGroupEl = el.find(".cost-retail-toggler");
  const costRetailBtnGroup = new QuickBtnGroup(costRetailBtnGroupEl, {distributeWidth: true});
  costRetailBtnGroup.init();

  const orderTypeBtnGroupEl = el.find(".order-type-toggler");
  const orderTypeBtnGroup = new QuickBtnGroup(orderTypeBtnGroupEl, {distributeWidth: true});
  orderTypeBtnGroup.init();

  const collateralRuleLogicEl = el.find(".collateral-rule-logic-toggler");
  const collateralRuleLogicBtnGroup = new QuickBtnGroup(collateralRuleLogicEl, {distributeWidth: true});
  collateralRuleLogicBtnGroup.init();


  // $(productSkus).each(function(){
  //   const option = $('<option />');
  //   option.attr('value', this.itmSku).text(this.itmSku);
  //   $("#productsInOrder").append(option);
  // });

  $(channels).each(function(){
    const option = $('<option />');
    option.attr('value', this.channelName).text(this.channelName);
    $("#channelInput").append(option);
  });

  isEdit();

  function isEdit() {

    if(!existingCollateralSkus || existingCollateralSkus.length <= 0) {
      $(".apply-to-collateral-empty").show();
      $(".apply-to-collateral-exists").hide();
    }


    if(existingRule) {
      $("#rule-name").val(existingRule.cbrName);
      $("#rule-description").val(existingRule.cbrDescription);
      $("#effectiveStartDate").val(existingRule.cbrEffectiveStartDate);
      $("#effectiveEndDate").val(existingRule.cbrEffectiveEndDate);
      collateralRuleLogicBtnGroup.activateBtnViaKey(existingRule.ruleLogic);
      let conditions = existingRule.cmrRuleConditions;
      if(conditions && "Specific Conditions" === existingRule.ruleLogic) {
        for (let i=0;i<conditions.length;i++) {
          if(conditions[i].byValOfOrder) {
            $('#byValOfOrder').prop('checked', true);
            let params = conditions[i].cmrRuleParams;
            if(params) {
              for (let j=0;j<params.length;j++) {
                $("#gte-dollars-1").val(params[j].crpValue);
                costRetailBtnGroup.activateBtnViaKey(params[j].crpKey);
              }
            }
          } else if(conditions[i].byProductsInOrder) {
            $('#byProductsInOrder').prop('checked', true);
            let params = conditions[i].cmrRuleParams;

            if(params) {
              let selectedValues = new Array();
              for (let j=0;j<params.length;j++) {
                selectedValues[j] = params[j].crpValue;
              }

              $("#productsInOrder").val(selectedValues);
             const relatedSelectPillsArray = _(params).pluck("crpValue");
             setOptionsForSelect({
                selectElement: productsInOrderSelect2,
                list: params,
                valueDataKey: "crpValue",
                textDataKey: "crpValue",
                initialSelectValue: relatedSelectPillsArray
              }); 

              listBuild =[];
              listBuild = selectedValues;
              ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
            }
          } else if(conditions[i].byQuantityOfOrder) {
            $('#byQuantityOfOrder').prop('checked', true);
            let params = conditions[i].cmrRuleParams;
            if(params) {
              for (let j=0;j<params.length;j++) {
                $("#quantityOfOrderVal").val(params[j].crpValue);
              }
            }
          } else if(conditions[i].byTypeOfOrder) {
            $('#byTypeOfOrder').prop('checked', true);
            let params = conditions[i].cmrRuleParams;
            if(params) {
              for (let j=0;j<params.length;j++) {
                orderTypeBtnGroup.activateBtnViaKey(params[j].crpValue);
              }
            }
          } else if(conditions[i].byChannel) {
            $('#byChannel').prop('checked', true);
            let params = conditions[i].cmrRuleParams;
            if(params) {
              let selectedValues = new Array();
              for (let j=0;j<params.length;j++) {
                selectedValues[j] = params[j].crpValue;
              }
              $("#channelInput").val(selectedValues);
              listBuild =[];
              listBuild = selectedValues;
              ruleSummaryOrderChannelValue.text(getSelectedValuesOfSelect2ById('channelInput'));
            }
          }
        }
        prepareSummaryForOrderConditions();
      }
    }


   if(existingCollateralSkus && existingCollateralSkus.length > 0) {
     for (let j=0;j<existingCollateralSkus.length;j++) {
      addProducts(existingCollateralSkus[j].itmSku,existingCollateralSkus[j].prdName,existingCollateralSkus[j].clrQtyPerRule);

      }
   }

  }

  $(".bundle-new-submit-link").on("click", function(e){
    e.preventDefault();
    if(validator.elements().valid()) {
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: submitModalTitleTxt,
        confirmModalBody: `<div class="q-pad-all-xl">${submitModalBodyTxt}</div>`,
        confirmModalBtnText: submitModalBtnTxt,
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          submitRule({url: submitRuleURL, success: submitRuleSuccess, error: submitRuleError});

          function submitRule({url, success, error}) {
            $.ajax({
              data:  $('#collateral-rule-form').serialize(),
              url: url,
              dataType:"JSON",
              type: 'POST',
              success: success,
              error: error
            });
          }

           function submitRuleSuccess(cbrId) {
            if(cbrId > 0){
              EditChecker.setPageClean();
              const ruleDetailUrl = el.data("rule-details-url");
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = `${ruleDetailUrl}&cbrId=${cbrId}`;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            } else {
              submitModalFlow.showFailureModal();
            }
          }

          function submitRuleError() {
            submitModalFlow.hideAllModals();
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  function inclusionConditionSetup(id, val){
    if(val==="all-orders"){
      collateralRuleConditionsDiv.hide();
      $(".collateral-product-rule-conditions").hide();
      ruleSummaryInclusionCondition.text("on ALL ORDERS ");
    }else if(val==="order-conditions"){
      collateralRuleConditionsDiv.show();
      $(".collateral-product-rule-conditions").hide();
      ruleSummaryInclusionCondition.text("in ORDERS WITH");
      prepareSummaryForOrderConditions();
    }else if(val==="order-products"){
      collateralRuleConditionsDiv.hide();
      $(".collateral-product-rule-conditions").show();
      ruleSummaryInclusionCondition.text("for SKUs");
      ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
    }
  }

  function inclusionFrequencySetup(id, val){
    ruleSummarySection.show();
    if(val==="per-order"){

      ruleSummaryInclusionFrequency.text("ONCE PER ORDER ");
    }else if(val==="per-sku"){
      ruleSummaryInclusionFrequency.text("WITH EACH ORDERED LINE ITEM ");
    }else if(val==="per-unit"){
       ruleSummaryInclusionFrequency.text("WITH EACH ORDERED UNIT ");
    }else{
      ruleSummarySection.hide();
    }
  }

   productsInOrderSelect2.on('change', function(){
     ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
   });

   collateralRuleConditionsDiv.on('change', function(){
    prepareSummaryForOrderConditions();
  });

  function prepareSummaryForOrderConditions(){
    let rlecnt = 0;
    ruleSummaryOrderSkuValue.text();
    if(byValOfOrderToggler.prop('checked')){
      ruleSummaryOrderConditions.text("value greater than or equal to ");
      orderValueInSummary.text("$" + $("#gte-dollars-1").val());
      rlecnt = rlecnt+1;
    }else if(!byValOfOrderToggler.prop('checked')){
      ruleSummaryOrderConditions.text("");
      orderValueInSummary.text("");
      rlecnt = rlecnt-1;
    }

    if(byQuantityOfOrder.prop('checked')){
      ruleSummaryOrderQuantity.text("order quantity greater than or equal to ");
      ruleSummaryOrderQuantityValue.text($("#quantityOfOrderVal").val());
    }else if(!byQuantityOfOrder.prop('checked')){
      ruleSummaryOrderQuantity.text("");
      ruleSummaryOrderQuantityValue.text("");
    }

    if(byTypeOfOrder.prop('checked')){
      ruleSummaryOrderType.text("order type ");
      ruleSummaryOrderTypeValue.text($("#orderTypeOption").val());
    }else if(!byTypeOfOrder.prop('checked')){
      ruleSummaryOrderType.text("");
      ruleSummaryOrderTypeValue.text("");
    }

    if(byChannel.prop('checked')){
      ruleSummaryOrderChannel.text("channels ");
      ruleSummaryOrderChannelValue.text(getSelectedValuesOfSelect2ById('channelInput'));
    }else if(!byChannel.prop('checked')){
      ruleSummaryOrderChannel.text("");
      ruleSummaryOrderChannelValue.text("");
    }
  }

  let typeAhead = $('.associated-collateral-typeahead.typeahead');
  typeAhead.typeahead(null, {
    name: 'typeAheadItems',
    limit: 5,
    source: typeAheadSource(typeAheadItems)
  }).on('typeahead:selected', function() {
    let str = this.value;
    let res = str.split("--");
      $(".apply-to-collateral-empty").hide();
      $(".apply-to-collateral-exists").show();
    addProducts(res[0],res[1],res[2]);
    typeAhead.typeahead('val', '');
   // triggerAddProductsEvent();

  });

  function addProducts(itmSku,productName,qtyPerRule){
     let highestId = parseInt($("#collateral-rule-table tbody tr:last").attr("id"));
    if(isNaN(highestId)){
      highestId = 0;
    }else{
      ++highestId;
    }

    if(qtyPerRule === undefined || qtyPerRule == 0){
      qtyPerRule=1;
    }

   let itmId="";
   itmId=findCollateralItemId(itmSku);
   const qty = '<td><div class="wrapper-helper"><input min="1" type="number" value="'+qtyPerRule+'"class="q-input stretch q-text-right collateral-qty-per-rule" name="collateral-qty-per-rule_row_'+ highestId +'" data-error-placement-append-closest=".wrapper-helper" placeholder=""/></div></td>';
   const removeIcon = '<td><div class="q-text-right"><a href="#" class="remove-collateral" aria-label="Remove"><i class="fa fa-close fa-lg q-pad-horz-md" aria-hidden="true"></i></a></div></td>';
   const productRow= "<tr id='"+ highestId + "'> <td><div><input name='associatedCollateral' value='"+ itmId +'_row_'+highestId+"' type='hidden'/> <input name='associatedCollateral_row_"+highestId+"' type='hidden' value='"+itmId+"'/>" +  itmSku + " </div></td> <td><div>" +  productName+ " </div></td>" + qty +" "+ removeIcon + "</tr>" ;

   $("#collateral-rule-table").find('tbody').append(productRow);

 }

 function findCollateralItemId(itmSku) {
    let itmId = "";
   _.each(collateralSkus, function(item) {
      if(item.itmSku===itmSku){
        itmId = item.itmId;
        return;
      }
  });
   return itmId;
 }

  doc.on('click', '#collateral-rule-form .remove-collateral', handleItemRemove);

  function handleItemRemove(e){
    EditChecker.setPageDirty();

    //change the method name to remove product related rows.
    e.preventDefault();
    removeClosestRow($(e.target));
 }

  function removeClosestRow(el){
    el.closest('tr').remove();
    $(".associated-collateral-typeahead").focus();
    let rowCount = $('#collateral-rule-table tr').length;
    if(rowCount==1){
      $(".apply-to-collateral-empty").show();
      $(".apply-to-collateral-exists").hide();
    }
  }

  function getSelectedValuesOfSelect2ById(id){
    let dataText="";
    $(`#${id} option:selected`).each(function () {
      let $this = $(this);
      if($.inArray($this.text(), listBuild)==-1){
        listBuild.push($this.text());
      }

    });

    for(let i=0; i<listBuild.length; i++){
      if(!dataText.includes(listBuild[i]) && i<listBuild.length-1){
        dataText = dataText.concat(listBuild[i].concat(", "));
      }else{
        dataText = dataText.concat(listBuild[i].concat(" "));
      }
    }
    return dataText;
  }

  function clearSummarySections(){
    listBuild =[];
    ruleSummaryInclusionCondition.text("");
    ruleSummaryInclusionFrequency.text("");
    ruleSummaryOrderConditions.text("");
    ruleSummaryOrderQuantity.text("");
    ruleSummaryOrderQuantityValue.text("");
    ruleSummaryOrderType.text("");
    ruleSummaryOrderTypeValue.text("");
    ruleSummaryOrderChannel.text("");
    ruleSummaryOrderChannelValue.text("");
    ruleSummaryConjunction.text("");
    ruleSummaryOrderSkuValue.text("");
    orderValueInSummary.text("");

  }

  
  productsInOrderSelect2.select2({
    ajax: {
      ...select2AjaxDefaults,
      url:productLookUpURL,
      data: configureDataCallback({paramKey: 'likeSku'})
    },
    minimumInputLength: 3
  });


}



// WEBPACK FOOTER //
// ./src/pages/createRule/collateralRule.js